import {
  DefaultLinkModel,
  DefaultPortModel,
  LinkModel,
} from "@projectstorm/react-diagrams";
import { toast } from "react-toastify";
import ComponentLinkModel from "./CustomLinkModel";
import ComponentLinkLabelModel from "./ComponentLinkLabelModel";
import { AbstractModelFactory } from "@projectstorm/react-canvas-core";

export default class ComponentPortModel extends DefaultPortModel {
  constructor(options: any) {
    super({ ...options, type: "component-port" });
  }

  createLinkModel(factory?: AbstractModelFactory<LinkModel>): LinkModel {
    const link = new DefaultLinkModel();
    link.addLabel(new ComponentLinkLabelModel());
    return link;
  }

  // createLinkModel() {
  //   // check if port is correct (we need Out port)
  //   if (this.options.in) {
  //     toast.error("You need to drag a link from Out Port.");
  //     // only one link is allowed per port
  //     // if (Object.keys(this.getLinks()).length > 0) {
  //     //   toast.error("You can drag only one link from a port.");
  //     //   return false;
  //     // }
  //   } else {
  //     const link = new DefaultLinkModel();
  //     link.addLabel(new ComponentLinkLabelModel({}));
  //     return link;
  //   }
  // }

  canLinkToPort(targetPort: ComponentPortModel) {
    if (
      Object.values(targetPort.links as any).some(
        (l: any) =>
          l.sourcePort?.parent.options.id === (this as any).parent.options.id
      ) ||
      Object.values((this as any).links as any).some(
        (l: any) =>
          l.targetPort?.parent.options.id === (this as any).parent.options.id
      )
    ) {
      toast.error("You can create only one link between two components.");
      return false;
    }

    if (!!(this as any).options.in === !!targetPort?.options.in) {
      toast.error("You can only link an OUT port and an IN port.");
      return false;
    }

    return true;
  }
}
